import React from 'react';
import {
  CompositeNavigationProp,
  useNavigation,
} from '@react-navigation/native';
import { StackNavigationProp } from '@react-navigation/stack';
import { useAuth } from '~/context/auth';
import { GroupStackParamList, RootStackParamList } from '~/navigation/types';
import JoinGroupRequestSentLayout from './layout';

type JoinGroupRequestSentNavProp = CompositeNavigationProp<
  StackNavigationProp<RootStackParamList>,
  StackNavigationProp<GroupStackParamList, 'JoinGroupRequestSent'>
>;

export default function JoinGroupRequestSent(): JSX.Element {
  const navigation = useNavigation<JoinGroupRequestSentNavProp>();

  const { onLogout } = useAuth();

  const logoutHandler = async () => {
    await onLogout();

    navigation.reset({
      routes: [{ name: 'AuthStack' }],
    });
  };

  return (
    <JoinGroupRequestSentLayout
      onLogout={() => logoutHandler()}
      onGoToLobby={() => {
        //hack to pop from GroupStack back to Main
        navigation.popToTop();
        navigation.goBack();
      }}
    />
  );
}

/**
 * TODO:
 * - Lottie animation
 */
